import React from 'react';
import { Check, Target, Users, TrendingUp, Calendar, BookOpen } from 'lucide-react';
import { Button } from './Button';
export function ProductReveal() {
  return <section className="py-20 px-4 bg-gradient-to-b from-[#0F1F3D] to-[#0A1628] border-t border-[#C6F432]/20" data-id="element-315">
      <div className="max-w-5xl mx-auto" data-id="element-316">
        <div className="text-center mb-16" data-id="element-317">
          <h2 className="text-5xl md:text-7xl font-anton text-[#C6F432] mb-4" data-id="element-318">
            🎾 MEGAPACK PADEL RESUELTO™
          </h2>
          <p className="text-2xl md:text-3xl text-white font-bold mb-8" data-id="element-319">
            El sistema que cambia todo
          </p>

          <div className="flex flex-wrap justify-center gap-6 mb-12" data-id="element-320">
            <div className="flex items-center gap-2 text-lg font-medium" data-id="element-321">
              <Check className="text-[#C6F432]" data-id="element-322" /> +300 páginas estructuradas
            </div>
            <div className="flex items-center gap-2 text-lg font-medium" data-id="element-323">
              <Check className="text-[#C6F432]" data-id="element-324" /> 60+ clases listas
            </div>
            <div className="flex items-center gap-2 text-lg font-medium" data-id="element-325">
              <Check className="text-[#C6F432]" data-id="element-326" /> Funciona desde hoy
            </div>
          </div>

          <div className="mb-16" data-id="element-327">
            <h3 className="text-gray-400 uppercase tracking-widest text-sm mb-4" data-id="element-328">
              Niveles incluidos
            </h3>
            <div className="flex justify-center gap-4 flex-wrap" data-id="element-329">
              <span className="bg-[#0A1628] border border-[#C6F432]/50 text-white px-6 py-2 rounded-full font-bold" data-id="element-330">
                Principiante
              </span>
              <span className="bg-[#0A1628] border border-[#C6F432]/50 text-white px-6 py-2 rounded-full font-bold" data-id="element-331">
                Intermedio
              </span>
              <span className="bg-[#0A1628] border border-[#C6F432]/50 text-white px-6 py-2 rounded-full font-bold" data-id="element-332">
                Avanzado
              </span>
            </div>
          </div>
        </div>

        <div className="bg-[#0A1628] border border-white/10 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-333">
          <h3 className="text-3xl font-anton text-center mb-10" data-id="element-334">
            Vas a dominar:
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8" data-id="element-335">
            <div className="flex flex-col items-center text-center gap-3" data-id="element-336">
              <div className="bg-[#0F1F3D] p-4 rounded-full text-[#C6F432]" data-id="element-337">
                <BookOpen size={32} data-id="element-338" />
              </div>
              <span className="font-bold text-lg" data-id="element-339">Fundamentos</span>
            </div>
            <div className="flex flex-col items-center text-center gap-3" data-id="element-340">
              <div className="bg-[#0F1F3D] p-4 rounded-full text-[#C6F432]" data-id="element-341">
                <Target size={32} data-id="element-342" />
              </div>
              <span className="font-bold text-lg" data-id="element-343">Técnica</span>
            </div>
            <div className="flex flex-col items-center text-center gap-3" data-id="element-344">
              <div className="bg-[#0F1F3D] p-4 rounded-full text-[#C6F432]" data-id="element-345">
                <Check size={32} data-id="element-346" />
              </div>
              <span className="font-bold text-lg" data-id="element-347">Corrección</span>
            </div>
            <div className="flex flex-col items-center text-center gap-3" data-id="element-348">
              <div className="bg-[#0F1F3D] p-4 rounded-full text-[#C6F432]" data-id="element-349">
                <TrendingUp size={32} data-id="element-350" />
              </div>
              <span className="font-bold text-lg" data-id="element-351">Progresión</span>
            </div>
            <div className="flex flex-col items-center text-center gap-3" data-id="element-352">
              <div className="bg-[#0F1F3D] p-4 rounded-full text-[#C6F432]" data-id="element-353">
                <Calendar size={32} data-id="element-354" />
              </div>
              <span className="font-bold text-lg" data-id="element-355">Planificación</span>
            </div>
            <div className="flex flex-col items-center text-center gap-3" data-id="element-356">
              <div className="bg-[#0F1F3D] p-4 rounded-full text-[#C6F432]" data-id="element-357">
                <Users size={32} data-id="element-358" />
              </div>
              <span className="font-bold text-lg" data-id="element-359">
                Clases grupales e individuales
              </span>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-360">
            <Button className="text-lg" data-id="element-361">SÍ, QUIERO EL SISTEMA AHORA</Button>
          </div>
        </div>
      </div>
    </section>;
}